export default __webpack_public_path__ + "static/media/Managersexl.64a90610.xlsx";